import React from "react";

interface EditContentModalShellProps {
    onClose: () => void;
    children: React.ReactNode;
}

export const EditContentModalShell: React.FC<EditContentModalShellProps> = ({
    onClose,
    children,
}) => (
    <div className="modal-overlay edit-modal-overlay" onClick={onClose}>
        <div
            className="modal-content edit-modal-content"
            onClick={(event) => event.stopPropagation()}
        >
            <button onClick={onClose} className="close-button" aria-label="Close edit modal">
                &times;
            </button>
            <div className="modal-body" style={{ textAlign: "center", padding: "40px" }}>
                {children}
            </div>
        </div>
    </div>
);
